import { render, staticRenderFns } from "./fornecedores.vue?vue&type=template&id=757b95e8"
import script from "./fornecedores.vue?vue&type=script&lang=js"
export * from "./fornecedores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports